import React, { useState, useRef, useEffect } from "react";
import "./ReleaseNotesModal.css";

const ReleaseNotesModal = ({ isOpen, onClose, video }) => {
  const [orgName, setOrgName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setOrgName("");
    setIsLoading(false);
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="release-notes-modal-overlay">
      <div className="release-notes-modal" ref={modalRef}>
        <button className="release-notes-close-button" onClick={onClose} />
        <h1 className="release-notes-modal-title">Комментарий</h1>
        <div className="release-notes-modal-content">
          <div
            style={{
              display: "block",
              whiteSpace: "pre-wrap",
              textAlign: "left",
            }}
          >
            {video.releaseNotes && video.releaseNotes.trim()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotesModal;
